import axios from './axiosConfig';

const API_URL = '/stages/';

const createStage = async (data) => { // OK
    return await axios.post(API_URL + 'create', data);
};

const getAllStages = async () => { // OK
    return await axios.get(API_URL + 'all');
};

const deleteStage = async (stageId) => { // OK
    return await axios.delete(API_URL + stageId);
};

const endStage = (stageId) => {
    return axios.post(API_URL + 'end-stage/' + stageId);
};

const updateStage = (stageId, updatedStage) => {
    return axios.put(API_URL + stageId, updatedStage);
};

const updatePenalidade = async (stageId) => {
    return await axios.put(API_URL + 'penalidades/' + stageId);
};

export default {
    createStage,
    getAllStages,
    deleteStage,
    endStage,
    updateStage,
    updatePenalidade,
};
